import React from 'react';
import {
  RatingConfigurator,
  MultipleSelectionConfigurator,
  CommentConfigurator,
  EmailConfigurator,
  SurveyFactory,
} from '@bingads-webui-campaign-react/survey-factory-tools';

const exampleSurveyConfig = (options) => {
  const {
    i18n,
  } = options;

  return {
    featureArea: 'WebUIUserCSAT',
    style: {
      root: {
        maxWidth: 480,
      },
    },
    others: {
      shouldHideInputWhenNotSelected: true,
      userActionAnalysisEnabled: true,
      combineTextInputToComment: true,
    },
    rating: {
      isRequired: true,
      Type: RatingConfigurator,
      key: 'rating',
      page: 0,
      position: 0,
      getTitle: () => i18n.getString(_TL_('Please rate your overall satisfaction with Microsoft Advertising\'s interface.')),
      isVisible: () => true,
      options: [
        {
          key: '5',
          text: i18n.getString(_TL_('Very satisfied')),
          rating: 1.0,
        },
        {
          key: '4',
          text: i18n.getString(_TL_('Moderately satisfied')),
          rating: 0.8,
        },
        {
          key: '3',
          text: i18n.getString(_TL_('Neither satisfied nor dissatisfied')),
          rating: 0.6,
        },
        {
          key: '2',
          text: i18n.getString(_TL_('Moderately dissatisfied')),
          rating: 0.4,
        },
        {
          key: '1',
          text: i18n.getString(_TL_('Very dissatisfied')),
          rating: 0.2,
        },
      ],
    },
    email: {
      Type: EmailConfigurator,
      key: 'email',
      page: 1,
      position: 2,
      getTitle: () => i18n.getString(_TL_('Can we follow up with you about your responses?')),
      isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
      options: [
        {
          key: 'yes',
          text: i18n.getString(_TL_('Yes - specify the contact email below')),
          placeholder: i18n.getString(_TL_('Enter your email')),
          hasInput: true,
        },
        {
          key: 'no',
          text: i18n.getString(_TL_('No')),
        },
      ],
    },
    questions: [
      {
        Type: MultipleSelectionConfigurator,
        key: 'q1',
        page: 1,
        position: 0,
        getTitle: (answers, surveyConfigurator) => {
          const questionConfigurator = surveyConfigurator.getQuestionByKey('rating');
          const optionKey = answers.rating.selectedOption;
          // option to text
          return i18n.getString(
            _TL_('Can you tell us more about where you are {{option}} with our interface?'),
            { option: questionConfigurator.optionKeyToText[optionKey] }
          );
        },
        isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
        options: [
          {
            key: 'q1o1',
            text: i18n.getString(_TL_('Campaign creation and editing')),
          },
          {
            key: 'q1o2',
            text: i18n.getString(_TL_('Interface navigation')),
          },
          {
            key: 'q1o3',
            text: i18n.getString(_TL_('Search and filtering')),
          },
          {
            key: 'q1o4',
            text: i18n.getString(_TL_('The overview page')),
          },
          {
            key: 'q1o5',
            text: i18n.getString(_TL_('Others - Please feel free to elaborate below')),
            placeholder: i18n.getString(_TL_('Please feel free to elaborate')),
            hasInput: true,
            maxLength: 2000,
          },
        ],
        data: {
        },
      },
      {
        Type: CommentConfigurator,
        key: 'q2',
        page: 1,
        position: 1,
        getTitle: () => i18n.getString(_TL_('How can we continue to improve?')),
        isVisible: answers => ['3', '2', '1'].includes(answers.rating.selectedOption),
        maxLength: 2000,
        data: {
        },
      },
    ],
  };
};

export const FactorySurveyView = props => (
  <SurveyFactory
    getSurveyConfiguration={exampleSurveyConfig}
    {...props}
  />);
